import { useApiData } from './useApiData'

type DiscoveryServiceResponse = {
  serviceName: string
  isOnline: boolean
  lastUpdated: Date
}

export function useServiceState({ serviceName, skip }: { serviceName: string; skip?: boolean }) {
  const { data: discovery, loading } = useApiData<DiscoveryServiceResponse>(
    {
      url: `/api/services/${serviceName}`,
      method: 'get'
    },
    { skip }
  )

  return {
    discovery,
    discoveryLoading: loading
  }
}
